<template>
  <div class="sbt">
    <!-- Note de contexte -->
    <div v-if="!existingStrategy" class="ov-hint sbt-note">
      Les champs marqués d'un astérisque (<span class="ov-required">*</span>) sont obligatoires.
    </div>
    <div v-else class="ov-note sbt-note">
      <v-icon small color="#159e72">mdi-check-circle-outline</v-icon>
      <span>Modifiez les prix et quantités dans le tableau, ou ajoutez de nouveaux types de bagages.</span>
    </div>

    <!-- Ligne d'ajout -->
    <div class="ov-row ov-row--price">
      <div class="ov-field">
        <label class="ov-label">Bagage<span class="ov-required">*</span></label>
        <select
          v-model="$v.bagageTypeModel.typeBagageDesignation.$model"
          class="ov-select"
          :class="{ 'is-invalid': $v.bagageTypeModel.typeBagageDesignation.$error }"
        >
          <option :value="null" disabled>Sélectionnez un type</option>
          <option
            v-for="(type, index) in referenceBagageTypeList"
            :key="index"
            :value="type.designation"
            :disabled="isTypeAlreadyAdded(type.designation)"
          >
            {{ type.designation }}{{ isTypeAlreadyAdded(type.designation) ? ' (déjà ajouté)' : '' }}
          </option>
        </select>
        <div v-if="$v.bagageTypeModel.typeBagageDesignation.$error" class="ov-error">Choisissez un type.</div>
      </div>

      <div class="ov-field">
        <label class="ov-label">Prix<span class="ov-required">*</span></label>
        <div class="ov-input-suffix">
          <input
            type="number"
            v-model.number="$v.bagageTypeModel.prix.$model"
            class="ov-input"
            :class="{ 'is-invalid': $v.bagageTypeModel.prix.$error }"
            placeholder="0"
            min="0"
          />
          <span>FCFA</span>
        </div>
        <div v-if="$v.bagageTypeModel.prix.$error" class="ov-error">Le prix est obligatoire.</div>
      </div>

      <div class="ov-field">
        <label class="ov-label">Qté gratuite<span class="ov-required">*</span></label>
        <input
          type="number"
          v-model.number="$v.bagageTypeModel.quantiteNonTaxable.$model"
          class="ov-input"
          :class="{ 'is-invalid': $v.bagageTypeModel.quantiteNonTaxable.$error }"
          placeholder="0"
          min="0"
        />
        <div v-if="$v.bagageTypeModel.quantiteNonTaxable.$error" class="ov-error">La quantité est obligatoire.</div>
      </div>

      <div class="ov-field">
        <button type="button" class="ov-btn ov-btn--navy" title="Ajouter" @click="addNewTypeBagageInStrategyType()">
          <v-icon small>mdi-plus</v-icon>
          Ajouter
        </button>
      </div>
    </div>

    <!-- Lignes de prix -->
    <div class="sbt-table">
      <v-data-table
        :headers="existingStrategy ? headersEdit : headers"
        :items="strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS"
        class="ov-table"
        no-data-text="Aucun type de bagage ajouté"
      >
        <!-- Prix -->
        <template v-slot:[`item.prix`]="{ item }">
          <div v-if="existingStrategy && isRowEditing(item)" class="ov-input-suffix sbt-inline">
            <input type="number" v-model.number="item.prix" class="ov-input" placeholder="0" min="0" />
            <span>FCFA</span>
          </div>
          <span v-else class="sbt-price">
            {{ item.prix ? item.prix.toLocaleString('fr-FR') : 0 }} <span class="sbt-currency">FCFA</span>
          </span>
        </template>

        <!-- Quantité non taxable -->
        <template v-slot:[`item.quantiteNonTaxable`]="{ item }">
          <input
            v-if="existingStrategy && isRowEditing(item)"
            type="number"
            v-model.number="item.quantiteNonTaxable"
            class="ov-input sbt-inline sbt-inline--qty"
            placeholder="0"
            min="0"
          />
          <span v-else>{{ item.quantiteNonTaxable }}</span>
        </template>

        <!-- Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="ov-row-actions">
            <!-- Mode création : supprimer -->
            <button
              v-if="!existingStrategy"
              type="button"
              class="ov-icon-btn ov-icon-btn--danger"
              title="Supprimer"
              @click="deleteTypeBagage(item)"
            >
              <v-icon small>mdi-delete-outline</v-icon>
            </button>
            <!-- Mode modification : éditer ou confirmer/annuler -->
            <template v-else>
              <template v-if="isRowEditing(item)">
                <button type="button" class="ov-icon-btn" title="Enregistrer" @click="saveRow(item)">
                  <v-icon small>mdi-check</v-icon>
                </button>
                <button type="button" class="ov-icon-btn ov-icon-btn--danger" title="Annuler" @click="cancelEdit(item)">
                  <v-icon small>mdi-close</v-icon>
                </button>
              </template>
              <button v-else type="button" class="ov-icon-btn" title="Modifier" @click="startEdit(item)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </button>
            </template>
          </div>
        </template>
      </v-data-table>
    </div>

    <div v-if="!existingStrategy" class="sbt-actions">
      <button type="button" class="ov-btn ov-btn--secondary" @click="reinitializeBagageTypeModel">
        <v-icon small>mdi-refresh</v-icon>
        Réinitialiser
      </button>
      <button
        type="button"
        class="ov-btn ov-btn--primary"
        :disabled="strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS.length == 0"
        @click="creerStrategieParType()"
      >
        <v-icon small>mdi-content-save-outline</v-icon>
        Enregistrer
      </button>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="56" color="#159e72"></v-progress-circular>
    </v-overlay>
    <v-alert ref="errorAlert" class="myalert" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import {
  API_CREATE_STRATEGIE_BAGAGE,
  API_UPDATE_STRATEGIE_BAGAGE,
  API_OBTENIR_REFERENCE_PAR_PAR_FAMILLE,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import $ from "jquery";

export default {
  name: "StrategieBagageType.vue",
  props: {
    typeStrategie: {
      type: String,
      required: true,
      default: "",
    },
    existingStrategy: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      errorMsg: null,
      overlay: null,
      isModified: false,

      search: "",
      headers: [
        { text: "Réference", value: "designation" },
        { text: "Type de bagage", value: "typeBagageDesignation" },
        { text: "Qte non taxable", value: "quantiteNonTaxable" },
        { text: "Prix", value: "prix" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersEdit: [
        { text: "Réference", value: "designation" },
        { text: "Type de bagage", value: "typeBagageDesignation" },
        { text: "Qte non taxable", value: "quantiteNonTaxable" },
        { text: "Prix", value: "prix" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editingRows: {},

      objectToSendReferenceBagage: {
        datas: [],
      },

      referenceBagage: {
        referenceFamilleDesignation: "referenceFamilleBagage",
      },

      editedIndex: -1,

      bagageTypeModel: {
        designation: null,
        prix: null,
        quantiteNonTaxable: null,
        typeBagageDesignation: null,
      },

      strategieBagageTypeModel: {
        data: {
          designation: null,
          typeStrategieBagageDesignation: null,
          strategieBagageTypeDTO: {
            designation: null,
            prixBagageParTypeDTOS: [],
          },
        },
      },

      referenceBagageTypeList: [],
    };
  },

  validations: {
    bagageTypeModel: {
      prix: {
        required,
      },
      quantiteNonTaxable: {
        required,
      },
      typeBagageDesignation: {
        required,
      },
    },
  },

  methods: {
    // Affiche l'alerte de CE widget. showErrorMessage() cible toutes les alertes
    // .alert-error de la page et ferait apparaître celle du parent, restée vide.
    showError() {
      const el = this.$refs.errorAlert && this.$refs.errorAlert.$el;
      if (!el) return;
      $(el).fadeIn();
      setTimeout(() => $(el).fadeOut(), 4000);
    },

    markAsModified() {
      this.isModified = true;
    },

    reinitializeBagageTypeModel() {
      //this.bagageTypeModel.designation = null;
      this.bagageTypeModel.prix = null;
      this.bagageTypeModel.quantiteNonTaxable = null;
      this.bagageTypeModel.typeBagageDesignation = null;
    },

    deleteTypeBagage(type) {
      this.editedIndex =
        this.strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS.indexOf(
          type
        );
      this.strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS.splice(
        this.editedIndex,
        1
      );
    },

    addNewTypeBagageInStrategyType() {
      this.$v.$touch();
      if (this.$v.bagageTypeModel.$invalid) {
        this.errorMsg =
          "Veuillez remplir les champs obligatoires ou entrez des informations correctes !!!";
        this.showError();
      } else {
        const alreadyExists =
          this.strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS
            .some(item => item.typeBagageDesignation === this.bagageTypeModel.typeBagageDesignation);

        if (alreadyExists) {
          this.errorMsg = "Ce type de bagage est déjà ajouté à la stratégie.";
          this.showError();
          return;
        }

        var bagageType = {
          designation: null,
          prix: null,
          quantiteNonTaxable: null,
          typeBagageDesignation: null,
        };

        bagageType.designation = this.bagageTypeModel.typeBagageDesignation;
        bagageType.prix = this.bagageTypeModel.prix;
        bagageType.quantiteNonTaxable = this.bagageTypeModel.quantiteNonTaxable;
        bagageType.typeBagageDesignation =
          this.bagageTypeModel.typeBagageDesignation;

        this.strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS.push(
          bagageType
        );

        // En mode modification : auto-activer l'édition pour ce nouveau type
        if (this.existingStrategy) {
          this.$set(this.editingRows, bagageType.typeBagageDesignation, {
            prix: bagageType.prix,
            quantiteNonTaxable: bagageType.quantiteNonTaxable,
          });
        }

        this.reinitializeBagageTypeModel();
        this.$v.$reset();
      }
    },

    isRowEditing(item) {
      return !!this.editingRows[item.typeBagageDesignation];
    },

    startEdit(item) {
      this.$set(this.editingRows, item.typeBagageDesignation, {
        prix: item.prix,
        quantiteNonTaxable: item.quantiteNonTaxable,
      });
    },

    cancelEdit(item) {
      const backup = this.editingRows[item.typeBagageDesignation];
      if (backup) {
        if (item.id) {
          // Ligne existante : restaurer les valeurs d'origine
          item.prix = backup.prix;
          item.quantiteNonTaxable = backup.quantiteNonTaxable;
        } else {
          // Nouvelle ligne (pas encore en base) : supprimer de la liste
          this.deleteTypeBagage(item);
        }
      }
      this.$delete(this.editingRows, item.typeBagageDesignation);
    },

    async saveRow(item) {
      this.overlay = true;
      const rowPayload = item.id
        ? { id: item.id, prix: item.prix, quantiteNonTaxable: item.quantiteNonTaxable }
        : { designation: item.designation, typeBagageDesignation: item.typeBagageDesignation, prix: item.prix, quantiteNonTaxable: item.quantiteNonTaxable };

      const payload = {
        data: {
          id: this.strategieBagageTypeModel.data.id,
          strategieBagageTypeDTO: {
            id: this.strategieBagageTypeModel.data.strategieBagageTypeDTO.id,
            prixBagageParTypeDTOS: [rowPayload],
          },
        },
      };

      await axios
        .put(API_UPDATE_STRATEGIE_BAGAGE, payload, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              this.$delete(this.editingRows, item.typeBagageDesignation);
              this.$emit('strategie-updated', response.data.status.message);
            } else {
              this.errorMsg = response.data.status.message;
              this.showError();
            }
          } else {
            this.errorMsg = "Erreur, opération de mise à jour impossible";
            this.showError();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          this.showError();
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    // Création de strategie par type.
    async creerStrategieParType() {
      this.overlay = true;
      this.strategieBagageTypeModel.data.typeStrategieBagageDesignation =
        this.typeStrategie;

      await axios
        .post(API_CREATE_STRATEGIE_BAGAGE, this.strategieBagageTypeModel, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              // Émettre un événement pour recharger la stratégie dans le parent
              this.$emit('strategie-created', response.data.status.message);
            } else {
              this.errorMsg = response.data.status.message;
              this.showError();
            }
          } else {
            this.errorMsg = "Erreur , opération de création impossible";
            this.showError();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          this.showError();
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    // Mise à jour de strategie par type.
    async updateStrategieParType() {
      this.overlay = true;

      // Construire le payload : types existants avec id, nouveaux sans id
      const prixBagageParTypeDTOS =
        this.strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS.map(item => {
          if (item.id) {
            // Type existant : on envoie l'id + les valeurs modifiées
            return {
              id: item.id,
              prix: item.prix,
              quantiteNonTaxable: item.quantiteNonTaxable,
            };
          } else {
            // Nouveau type ajouté en mode modification : pas d'id
            return {
              designation: item.designation,
              typeBagageDesignation: item.typeBagageDesignation,
              prix: item.prix,
              quantiteNonTaxable: item.quantiteNonTaxable,
            };
          }
        });

      const updatePayload = {
        data: {
          id: this.strategieBagageTypeModel.data.id,
          strategieBagageTypeDTO: {
            id: this.strategieBagageTypeModel.data.strategieBagageTypeDTO.id,
            prixBagageParTypeDTOS,
          },
        },
      };

      await axios
        .put(API_UPDATE_STRATEGIE_BAGAGE, updatePayload, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.status.code == 800) {
              this.isModified = false;
              this.$emit('strategie-updated', response.data.status.message);
            } else {
              this.errorMsg = response.data.status.message;
              this.showError();
            }
          } else {
            this.errorMsg = "Erreur, opération de mise à jour impossible";
            this.showError();
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          this.showError();
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    //Obtenir la liste des types de bagages
    async obtenirReferenceTypeBagage() {
      this.objectToSendReferenceBagage.datas.push(this.referenceBagage);
      await axios
        .post(
          API_OBTENIR_REFERENCE_PAR_PAR_FAMILLE,
          this.objectToSendReferenceBagage,
          { headers: HEADERS(this.$store.state.userAuthentified.token) }
        )
        .then((response) => {
          this.referenceBagageTypeList = response.data.items;
        })
        .catch((e) => {
          this.errorMsg = e;
          this.showError();
        });
    },
  },

  computed: {
    isTypeAlreadyAdded() {
      return (designation) =>
        this.strategieBagageTypeModel.data.strategieBagageTypeDTO.prixBagageParTypeDTOS
          .some(item => item.typeBagageDesignation === designation);
    },
  },

  mounted() {
    this.obtenirReferenceTypeBagage();
    
    // Si une stratégie existante est fournie, charger ses données
    if (this.existingStrategy) {
      this.strategieBagageTypeModel.data = JSON.parse(JSON.stringify(this.existingStrategy));
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/ui";

.sbt {
  font-family: "Montserrat", sans-serif;

  button,
  input,
  select {
    font-family: "Montserrat", sans-serif;
  }
}

.sbt-note {
  margin: 0 0 18px;
}

/* Le bouton "Ajouter" s'aligne sur le bas des champs */
.ov-row--price {
  align-items: start;

  > .ov-field:last-child {
    padding-top: 27px;
  }
}

.sbt-table {
  margin-top: 22px;
  border: 1px solid $ov-line;
  border-radius: 12px;
  overflow: hidden;
}

.sbt-price {
  font-weight: 800;
  color: $ov-navy;
}

.sbt-currency {
  margin-left: 2px;
  font-size: 12px;
  font-weight: 700;
  color: $ov-green;
}

.sbt-inline {
  width: 150px;

  .ov-input {
    height: 36px;
  }

  &--qty {
    width: 90px;
    height: 36px;
  }
}

.sbt-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid $ov-line;
}

@media (max-width: 760px) {
  .ov-row--price > .ov-field:last-child {
    padding-top: 0;
  }

  .ov-row--price .ov-btn,
  .sbt-actions .ov-btn {
    width: 100%;
  }
}
</style>
